function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import store from "../shop/store";
import voyadoPurchase from "../components/analytics-ca";
import Newsletter from "../components/newsletter";
var getVoyadoOptions = function getVoyadoOptions(body, method) {
  var fetchOptions = {
    mode: "cors",
    cache: "no-cache",
    method: method,
    headers: {
      Accept: "application/json, text/plain, */*;"
    },
    body: body
  };
  return fetchOptions;
};
var fetchVoyado = function fetchVoyado(path, responseData, requestBody, method) {
  // POST /newsletter-subscription
  if (method === "POST" && /newsletter-subscription/.test(path)) {
    var email = path.substring(path.lastIndexOf("/") + 1, path.length);
    addContact(email, requestBody.country, requestBody.gender);
  }

  // POST /payment-result
  if (method === "POST" && /payment-result/.test(path)) {
    var isNewsletterChecked = typeof store.getState().payment.address.newsletter !== 'undefined' && store.getState().payment.address.newsletter;
    updateContact(responseData, isNewsletterChecked);
    voyadoPurchase();
  }

  // PUT /customer/update
  if (method === "PUT" && /customer\/update/.test(path)) {
    updateContact({
      order: {
        address: responseData.loggedIn
      }
    }, responseData.loggedIn.newsletter);
  }

  // PUT /email
  if (method === "PUT" && /email/.test(path)) {
    updateContact({
      order: {
        address: responseData.loggedIn
      }
    }, responseData.loggedIn.newsletter, true);
  }

  // POST /register
  if (method === "POST" && /register/.test(path) && !responseData.errors) {
    updateContact({
      order: {
        address: responseData.loggedIn
      }
    }, responseData.loggedIn.newsletter, true);
  }
};
var addContact = function addContact(email, country, gender) {
  var formdata = new FormData();
  if (country !== undefined) {
    formdata.append("country", country);
  }
  if (gender !== undefined) {
    formdata.append("gender", gender);
  }
  var form = document.querySelector('.js-newsletter[data-processing="true"]');
  var button = form ? form.querySelector('button[type="submit"]') : null;
  if (form == undefined) {
    return;
  }

  // Check values
  var $this = $(form);
  var formInputs = $this.serializeArray().reduce(function (acc, input) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, input.name, input.value));
  }, {});
  if (formInputs.source !== undefined) {
    formdata.append("source", formInputs.source);
  }
  return fetch("/wp-json/coalesce/v2/voyado/newsletter-signup/".concat(email), getVoyadoOptions(formdata, "POST")).then(function (data) {
    return data.json();
  }).then(function (data) {
    // If form is interstellar, change message to interstellar message
    if (form && form.classList.contains("newsletter-interstellar-form")) {
      data.message = data.message_interstellar || data.message;
    }
    setTimeout(function () {
      button.classList.remove(Newsletter.getClasses().isLoading);
      form.setAttribute("data-processing", false);
      Newsletter.formSuccess(form, data);
    }, 1500);
    var targetEl = $(form.dataset.target);
    if (targetEl && targetEl.attr('id') === 'js-newsletter-modal') {
      var displayTime = targetEl.data('display_time');
      if (form.dataset.success_type === 'alert') {
        displayTime = 0;
      }
      Newsletter.forceCloseModal(targetEl, displayTime);
    }
  }).catch(function (err) {
    button.classList.remove(Newsletter.getClasses().isLoading);
    form.setAttribute("data-processing", false);
    console.log("DEBUG: was not able to be fetched", err);
  });
};
var updateContact = function updateContact(orderData, isSubscribed) {
  var isEmailChanged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var formdata = new FormData();
  formdata.append("order", JSON.stringify(orderData.order));
  formdata.append("is_subscribed", isSubscribed);
  formdata.append("is_email_changed", isEmailChanged);
  return fetch("/wp-json/coalesce/v2/voyado/update_contact", getVoyadoOptions(formdata, "POST")).then(function (data) {
    return data.json();
  }).catch(function (err) {
    return console.log("DEBUG: was not able to be fetched", err);
  });
};
var fetchVoyadoContactId = function fetchVoyadoContactId(email) {
  return fetch("/wp-json/coalesce/v2/voyado/get_contact_id/".concat(email), getVoyadoOptions(null, "GET")).then(function (data) {
    return data.json();
  }).catch(function (err) {
    return console.log("DEBUG: was not able to be fetched", err);
  });
};
export { fetchVoyadoContactId, updateContact };
export default fetchVoyado;


// WEBPACK FOOTER //
// ./scripts/components/voyado.js